import { render, staticRenderFns } from "./CollectionPage.vue?vue&type=template&id=7a573ee0&scoped=true&"
import script from "./CollectionPage.vue?vue&type=script&lang=js&"
export * from "./CollectionPage.vue?vue&type=script&lang=js&"
import style0 from "./CollectionPage.vue?vue&type=style&index=0&id=7a573ee0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a573ee0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
